import ModalPopup from 'Components/Lib/Common/ModalPopup';
import { AddViewProvider } from 'Components/Lib/CRM/AddView';
import Addbutton from 'Components/Lib/Elements/Addbutton';
import MainSearch from 'Components/Lib/Elements/MainSearch';
import { getPropertiesPerType } from 'Helpers/getPropertiesPerType';
import { deleteCookie, getCookieValue } from 'Helpers/MFXCookie';
import LocalStorage from 'Helpers/MFXLocalStorage';
import SessionStorage from 'Helpers/MFXSessionStorage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from 'Styles/images/logo.png';
import deleteData from '../Lib/Utils/deleteData';
import loadJsonData from '../Lib/Utils/loadJsonData';
import loadJsonPost from '../Lib/Utils/jsonPost';
import sessionedLink from '../Lib/Utils/sessionedLinks';
import URLS from '../Lib/Utils/URLs.API';
import Headline from 'Components/Lib/Elements/MainHeadline';
import loadJsonPut from 'Components/Lib/Utils/jsonPut';
import WikiInfo from 'Components/Lib/Elements/WikiInfo';
import { useSearchParams } from 'react-router-dom';

/**
 * Header (Logo, DB Change, Search, Version, Add Note, User, Logout)
 * @returns {JSX.Element} Rendered component
 */

const Topheader = () => {
    const [submenuOpen, setSubmenuOpen] = useState(false);
    const [version, setVersion] = useState(null);
    const [mobile, setMobile] = useState(window.innerWidth <= window.mobileBreakPoint ? true : false);
    const [menuState, setMenuState] = useState({
        versionOpen: false,
        addMode: false,
        subUserOpen: false,
    });
    const [databaseList, setDatabaseList] = useState(null);
    const [roleList, setRoleList] = useState(null);
    const [subUsers, setSubUsers] = useState(null);
    const [showTimerecording, setShowTimerecording] = useState(false);



    const [typeParam, setTypeParam] = useState(useSearchParams()[0].get('type') ?? '');

    function handleResize() {
        if (window.innerWidth <= window.mobileBreakPoint) setMobile(true);
        else setMobile(false);
    }
    window.addEventListener('resize', handleResize);

    /* ---------- Load Versions and Databases --------- */
    useEffect(() => {
        if (LocalStorage?.getConnectionKey()) {
            loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.Versions).then(data => {
                if (data.Meta.Success && data.Data) {
                    setVersion(data.Data);
                }
            });
            loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetLoginableDatabases).then(data => {
                if (data.Meta.Success && data.Data) {
                    setDatabaseList(data.Data.Databases);
                }
            });
            loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetUserGroups).then(groups => {
                loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetUsers + '?Username=' + LocalStorage.getData('UserName')).then(data => {
                    if (data.Meta.Success && data.Data && data.Data[0]) {
                        var groupIDs = data.Data[0].OtherUserGroupIDs?.split(',').map(d => +d);
                        if (groupIDs) groupIDs?.unshift(data.Data[0].UserGroupID);
                        else groupIDs = [data.Data[0].UserGroupID];
                        setRoleList(
                            groupIDs.map(g => {
                                return groups?.Data?.find(group => group.UserGroupID === g)?.Name;
                            })
                        );
                    }
                });
            });
            loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetBusinessProcess + 'CRM&PageLayout=default').then((data) => {
                if (data.Meta.Success && data.Data && data.Data.Json?.entries?.find(i => i.link === '/processes/timerecording')) {
                  setShowTimerecording(true);
                }
                else {
                    setShowTimerecording(false);
                }
              });
        }
    }, []);

    useEffect(() => {
        if (LocalStorage?.getConnectionKey())
            loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetSubordinateUsers).then(data => {
                if (data.Meta.Success && data.Data) {
                    setSubUsers(data.Data);
                }
            });
    }, [menuState.subUserOpen]);

    /* ---------- On Change DB --------- */
    function changeDB(val) {
        loadJsonPost('/' + LocalStorage?.getConnectionKey() + URLS.LoginOtherDB, { Database: val, Language: getCookieValue('MFX_LANGUAGE') ?? 'deutsch' }).then(data => {
            if (data.Meta.Success && data.Data) {
                setDatabaseList(data.Data.Databases);
                const key = LocalStorage.createDBStorage({ key: data.Data.ConnectionKey, db: val }, { primaryId: -1, primaryType: 'start', context: {} });
                window.open('/' + key, '_blank');
            }
        });
    }

    function changeRole(val) {
        LocalStorage.createSession('UserRole', val);
        window.location.reload();
    }

    function updateIssetByInx(array, targetInx, newValue) {
        if (!array) return false;
        for (const obj of array) {
            if (obj.EmployeeIndex === targetInx) {
                obj.IsSet = newValue;
            }
            if (updateIssetByInx(obj.SubordinateUsers, targetInx, newValue)) {
                return true;
            }
        }
        return false;
    }

    //#region SubUser

    function changeSubUser(check, inx) {
        setSubUsers(prev => {
            var newSubUsers = [...prev];
            updateIssetByInx(newSubUsers, inx, check);
            return newSubUsers;
        });
    }

    function getSubUserView(user, level = 1) {
        return (
            <div>
                <div className="mfx-checkbox-element">
                    <input type="checkbox" checked={user.IsSet} onChange={e => changeSubUser(e.target.checked, user.EmployeeIndex)}></input>
                    <label>
                        {user.FirstName} {user.LastName}
                    </label>
                </div>
                <div className={'sub-' + level} style={{ paddingLeft: '2rem', width: 'fit-content' }}>
                    {user.SubordinateUsers?.map(subUser => getSubUserView(subUser, level + 1))}
                </div>
            </div>
        );
    }

    function updateSubUsers() {
        loadJsonPut('/' + LocalStorage?.getConnectionKey() + URLS.UpdateSubordinateUsers, subUsers).then(data => {
            if (data.Meta.Success) {
                setMenuState({ ...menuState, subUserOpen: false });
                window.location.reload(true);
            } else {
                alert('An Error occured while saving the SubUsers');
                setMenuState({ ...menuState, subUserOpen: false });
            }
        });
    }

    //#endregion SubUser

    function getLayoutName(){
        if(window.location.pathname.replace('processes', 'pages').slice(1).split('/').slice(2).join('/') === 'detailview'){
            return typeParam ?? 'default';
        }
        return LocalStorage.getData('UserRole') ?? 'default';
    }

    function openNewTimeRecordingTab() {
        console.log('xX');
        LocalStorage.createTab(
            {
                primaryId: 1,
                primaryType: 'timerecording',
            },
            true,
            true,
            '/processes/timerecordingoverview',
            '/processes/timerecordingoverview'
        );
    }

    return (
        <div id="mfx-topheader">
            {/* ---------- Left side of Header --------- */}

            <div id="mfx-logocontainer">
                {/* MULTIFLEX Logo */}
                <img src={Logo} id="logo" alt="Logo" />
                {/* renders CLIENT Logo  - via DataURI (from Database) */}
                <div id="clientlogo"></div>
            </div>

            {/* ---------- Right side of Header --------- */}
            <div id="mfx-infocontainer">
                {!mobile && (
                    <>
                        <span className="username">{LocalStorage.getUsername()}</span>
                        <div className="mfx-dropdown-element change-db">
                            <select onChange={e => changeDB(e.target.value)}>
                                <option>{LocalStorage.getDBName()}</option>
                                {databaseList?.map(database => {
                                    if (database.Name !== LocalStorage.getDBName()) return <option value={database.Name}>{database.Name}</option>;
                                })}
                            </select>
                        </div>
                        {roleList?.length > 1 && (
                            <div className="mfx-dropdown-element change-db">
                                <select id={'select-role'} value={LocalStorage.getData('UserRole')} onChange={e => changeRole(e.target.value)}>
                                    {roleList?.map(role => {
                                        return (
                                            <option id={'option-role-' + role} value={role}>
                                                {role}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}
                    </>
                )}
                {/* ---------- MainSearch --------- */}
                <MainSearch />

                {/* ---------- Desktop Buttons (Help & AddNote) --------- */}
                {!mobile && (
                    <>
                        <div>
                            <WikiInfo></WikiInfo>
                        </div>
                        <div id="help">
                            <i title={window.Dictionary.getTranslation(1037)} className="icon-help" onClick={() => setMenuState({ ...menuState, versionOpen: true })}></i>
                        </div>
                        <div id="addNote">
                            <i title={window.Dictionary.getTranslation(14355)} className="icon-add" onClick={() => setMenuState({ ...menuState, addMode: true })}></i>
                        </div>
                    </>
                )}

                {/* ---------- Submenu --------- */}
                <nav id="user" className={submenuOpen ? 'active' : ''}>
                    <ul className="menu">
                        <li>
                            <i
                                id="header-open-user-menu"
                                className="icon-user"
                                onClick={() => {
                                    setSubmenuOpen(!submenuOpen);
                                    setTimeout(() => {
                                        setSubmenuOpen(false);
                                    }, 3000);
                                }}></i>
                            <ul className={`sub-menu ${submenuOpen ? 'open' : ''}`}>
                                {mobile && (
                                    <>
                                        <li>
                                            <div className="mfx-dropdown-element change-db">
                                                <select onChange={e => changeDB(e.target.value)}>
                                                    <option>{LocalStorage.getDBName()}</option>
                                                    {databaseList?.map(database => {
                                                        if (database.Name !== LocalStorage.getDBName()) return <option value={database.Name}>{database.Name}</option>;
                                                    })}
                                                </select>
                                            </div>
                                        </li>
                                        {roleList?.length > 1 && (
                                            <li>
                                                <div className="mfx-dropdown-element change-db">
                                                    <select id={'select-role'} value={LocalStorage.getData('UserRole')} onChange={e => changeRole(e.target.value)}>
                                                        {roleList?.map(role => {
                                                            return (
                                                                <option id={'option-role-' + role} value={role}>
                                                                    {role}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </li>
                                        )}
                                        <li>
                                            <WikiInfo url={'header'}></WikiInfo>
                                        </li>
                                        <li id="help">
                                            <button onClick={() => setMenuState({ ...menuState, versionOpen: true })}>{window.Dictionary?.getTranslation(1037)}</button>
                                        </li>
                                        <li id="addNote">
                                            <button onClick={() => setMenuState({ ...menuState, addMode: true })}>{window.Dictionary?.getTranslation(14206)}</button>
                                        </li>
                                    </>
                                )}
                                {/* ---------- Link to User --------- */}
                                <li>
                                    <Link id="header-user" to={sessionedLink('/processes/user')}>
                                        {window.Dictionary?.getTranslation(2489)}
                                    </Link>
                                </li>
                                {/* ---------- Link to Designer --------- */}
                                {!mobile && LocalStorage.getData('UserData').IsAdministrator && (
                                    <li>
                                        <Link
                                            id="header-designer"
                                            to={'/designer/' + (LocalStorage.getDBData().prefix || 'NO_SESSION') + '/' + window.location.pathname.replace('processes', 'pages').slice(1).split('/').slice(1).join('/') + '?layoutName=' + getLayoutName()}
                                            target="_blank">
                                            {window.Dictionary?.getTranslation(14203)}{' '}
                                        </Link>
                                    </li>
                                )}
                                {/* ---------- Link to Time Recording --------- */}
                                {/*<li>
                                    <Link id="header-time-recording" to={sessionedLink('/processes/timerecording')}>
                                        {window.Dictionary?.getTranslation(1425)}
                                    </Link></li>*/}
                                {showTimerecording && 
                                    <li>
                                        <button id="header-timerecording" onClick={() => openNewTimeRecordingTab()}>{window.Dictionary?.getTranslation(1425)}</button>
                                    </li>
                                }
                                {subUsers && subUsers[0]?.SubordinateUsers?.length > 0 && (
                                    <li>
                                        <button onClick={() => setMenuState({ ...menuState, subUserOpen: true })}>{window.Dictionary?.getTranslation(16770)}</button>
                                    </li>
                                )}

                                {/* ---------- Logout--------- */}
                                <li>
                                    <button
                                        className="no-styling"
                                        id="header-logout"
                                        onClick={() => {
                                            deleteData('/' + LocalStorage?.getConnectionKey() + URLS.Logout)
                                                .then(data => {
                                                    if (data.Meta.Success) {
                                                        LocalStorage.removeAllLocals();
                                                        SessionStorage.removeAllStorage();
                                                        SessionStorage.createSession('Logout', window.location.href);
                                                        deleteCookie('MFX_Login');
                                                    }
                                                })
                                                .catch(e => {
                                                    console.log(e);
                                                });
                                        }}>
                                        {window.Dictionary?.getTranslation(3317)}
                                    </button>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>

            {/* ---------- POPUPS --------- */}
            {
                /*
                 * Renders a PopUp with the Main Information
                 */
                menuState.versionOpen && (
                    <ModalPopup>
                        <div class="mfx-action-buttons">
                            <button type="button" className="mfx-button mfx-button-type-icon" onClick={() => setMenuState({ ...menuState, versionOpen: false })}>
                                <i class="icon-close"></i>
                            </button>
                        </div>
                        <h3>{window.Dictionary.getTranslation(791)}</h3>
                        <p>.Net Version: {version.DotNetMajorVersion}</p>
                        <p>BuildDate: {new Date(Date.parse(version.BuildDate)).toLocaleString('de-DE')}</p>
                        <p>CRM Version: {version.PLXSuite}</p>
                        <p>DB Version: {version.DataBaseVersion}</p>
                        <p>Connection-Key: {LocalStorage?.getConnectionKey()}</p>
                        <button onClick={() => setMenuState({ ...menuState, versionOpen: false })}>{window.Dictionary.getTranslation(1650)}</button>
                    </ModalPopup>
                )
            }
            {
                /*
                 * Renders a Note-Addform
                 */
                menuState.addMode && (
                    <ModalPopup modalClass="mfx-add-modal">
                        <AddViewProvider changeView={() => setMenuState({ ...menuState, addMode: false })} viewName={'NoteAddView'} viewSettings={getPropertiesPerType('NoteView')}>
                            <div className="mfx-action-buttons">
                                <Addbutton disableChangeHandler={() => setMenuState({ ...menuState, addMode: false })} disableMode={() => setMenuState({ ...menuState, addMode: false })} save={false} />
                            </div>
                        </AddViewProvider>
                    </ModalPopup>
                )
            }

            {
                /*
                 * Renders a Sub-User form
                 */
                menuState.subUserOpen && (
                    <ModalPopup>
                        <div class="mfx-action-buttons">
                            <button type="button" className="mfx-button mfx-button-type-icon" onClick={() => setMenuState({ ...menuState, subUserOpen: false })}>
                                <i class="icon-close"></i>
                            </button>
                        </div>
                        <div className="mfx-element-headline headline-main">
                            <Headline designData={{ Subheadline: '', Headline: window.Dictionary.getTranslation(16770), IconColor: '#177868', Icon: 'icon-leads' }} />
                        </div>

                        <div className="sub-user-menu">{getSubUserView(subUsers[0])}</div>
                        <button onClick={() => updateSubUsers()}>{window.Dictionary.getTranslation(1778)}</button>
                    </ModalPopup>
                )
            }
        </div>
    );
};

export default Topheader;
